import { Instagram } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const prints = [
    "/img/feedback-1.webp",
    "/img/feedback-2.webp",
    "/img/feedback-3.webp",
    "/img/feedback-4.webp",
];

export default function Testimonials() {
    return (
        <section
            id="avaliacoes"
            data-testid="testimonials-section"
            className="border-y border-line bg-cream py-20 sm:py-28 lg:py-36"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Eyebrow>Prova social</Eyebrow>
                <Reveal delay={0.1}>
                    <h2 className="mt-5 max-w-3xl font-display text-3xl font-medium uppercase leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        O que seus clientes dizem
                        <span className="italic text-accent"> também vende.</span>
                    </h2>
                </Reveal>

                <div className="mt-14 columns-1 gap-6 sm:columns-2 lg:columns-4">
                    {prints.map((p, i) => (
                        <Reveal key={p} delay={(i % 4) * 0.08} className="mb-6 break-inside-avoid">
                            <figure
                                data-testid={`testimonial-card-${i + 1}`}
                                className="group overflow-hidden rounded-2xl border border-line bg-paper shadow-sm"
                            >
                                <img
                                    src={p}
                                    alt={`Feedback real de cliente do Studio Danielly Sousa — print ${i + 1}`}
                                    loading="lazy"
                                    className="w-full transition-transform duration-700 group-hover:scale-[1.02]"
                                />
                                <figcaption className="flex items-center gap-2 border-t border-line px-4 py-3">
                                    <Instagram size={13} className="text-accent" />
                                    <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-ink-soft">
                                        Feedback real — Instagram
                                    </span>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
